































import { Component, Prop, Provide, Watch, Vue } from "vue-property-decorator";

export enum State {
  okay = 0,
  loading = 1,
  error = 2
}

@Component
export default class StateContainer extends Vue {
  @Prop({ default: State.okay }) private state?: State;
  @Prop() message?: string;

  @Provide() private stateType = State;
  @Provide() private stateMessage = StateContainer.defaultMessageForState(
    this.state,
    this.message
  );

  @Watch("state")
  onStateChanged(val: State) {
    this.stateMessage = StateContainer.defaultMessageForState(
      val,
      this.message
    );
  }

  static defaultMessageForState(
    state: State | undefined,
    message: string | undefined
  ): string {
    switch (state) {
      case State.loading:
        return message ? message : "Plotting data...";
      case State.error:
        return message ? message : "This data cannot be displayed at this time";
      default:
        return message || "";
    }
  }
}
